export const levels = [
  {
    "id": 0,
    "folder": "000-zodiac",
    "category": 1
  },
  {
    "id": 1,
    "folder": "001-fruit",
    "category": 5
  },
  {
    "id": 2,
    "folder": "002-vehicle",
    "category": 8
  },
  {
    "id": 3,
    "folder": "003-internal-organs",
    "category": 1
  },
  {
    "id": 4,
    "folder": "004-colour",
    "category": 6
  },
  {
    "id": 5,
    "folder": "005-reading-table",
    "category": 7
  },
  {
    "id": 6,
    "folder": "006-khong-canh-ma-bay",
    "category": 6
  },
  {
    "id": 7,
    "folder": "007-kimbap",
    "category": 5
  },
  {
    "id": 8,
    "folder": "008-mothers-day",
    "category": 9
  },
  {
    "id": 9,
    "folder": "009-body",
    "category": 1
  },
  {
    "id": 10,
    "folder": "010-face",
    "category": 1
  },
  {
    "id": 11,
    "folder": "011-hand",
    "category": 1
  },
  {
    "id": 12,
    "folder": "012-foot",
    "category": 1
  },
  {
    "id": 13,
    "folder": "013-money",
    "category": 6
  },
  {
    "id": 14,
    "folder": "014-house",
    "category": 6
  },
  {
    "id": 15,
    "folder": "015-sick",
    "category": 4
  },
  {
    "id": 16,
    "folder": "016-direction",
    "category": 6
  },
  {
    "id": 17,
    "folder": "017-weather",
    "category": 6
  },
  {
    "id": 18,
    "folder": "018-school-subject",
    "category": 7
  },
  {
    "id": 19,
    "folder": "019-post",
    "category": 6
  },
  {
    "id": 20,
    "folder": "020-face-cleaning",
    "category": 6
  },
  {
    "id": 21,
    "folder": "021-map",
    "category": 3
  },
  {
    "id": 22,
    "folder": "022-ball-sports",
    "category": 2
  },
  {
    "id": 23,
    "folder": "023-board-games",
    "category": 2
  },
  {
    "id": 24,
    "folder": "024-camping",
    "category": 2
  },
  {
    "id": 25,
    "folder": "025-magical-elements",
    "category": 9
  },
  {
    "id": 26,
    "folder": "026-first-aid-kit",
    "category": 4
  },
  {
    "id": 27,
    "folder": "027-wedding",
    "category": 9
  },
  {
    "id": 28,
    "folder": "028-pen",
    "category": 7
  },
  {
    "id": 29,
    "folder": "029-solar-system",
    "category": 3
  },
  {
    "id": 30,
    "folder": "030-tree",
    "category": 1
  },
  {
    "id": 31,
    "folder": "031-blood",
    "category": 4
  },
  {
    "id": 32,
    "folder": "032-mountain",
    "category": 3
  },
  {
    "id": 33,
    "folder": "033-street",
    "category": 8
  },
  {
    "id": 34,
    "folder": "034-film-genre",
    "category": 2
  },
  {
    "id": 35,
    "folder": "035-education",
    "category": 7
  },
  {
    "id": 36,
    "folder": "036-art",
    "category": 2
  },
  {
    "id": 37,
    "folder": "037-feeling",
    "category": 4
  },
  {
    "id": 38,
    "folder": "038-cooking",
    "category": 5
  },
  {
    "id": 39,
    "folder": "039-agriculture",
    "category": 9
  },
  {
    "id": 40,
    "folder": "040-energy",
    "category": 9
  },
  {
    "id": 41,
    "folder": "041-trade",
    "category": 9
  },
  {
    "id": 42,
    "folder": "042-movie-theater",
    "category": 2
  },
  {
    "id": 43,
    "folder": "043-sea",
    "category": 3
  },
  {
    "id": 44,
    "folder": "044-working-dog",
    "category": 1
  },
  {
    "id": 45,
    "folder": "045-medium-of-exchange",
    "category": 9
  },
  {
    "id": 46,
    "folder": "046-natural-composition",
    "category": 3
  },
  {
    "id": 47,
    "folder": "047-unit-of-time",
    "category": 6
  },
  {
    "id": 48,
    "folder": "048-painting",
    "category": 2
  },
  {
    "id": 49,
    "folder": "049-cosmetics",
    "category": 9
  },
  {
    "id": 50,
    "folder": "050-honey-bee",
    "category": 1
  },
  {
    "id": 51,
    "folder": "051-meat-products",
    "category": 5
  },
  {
    "id": 52,
    "folder": "052-seasons",
    "category": 3
  },
  {
    "id": 53,
    "folder": "053-war",
    "category": 9
  },
  {
    "id": 54,
    "folder": "054-employment",
    "category": 9
  },
  {
    "id": 55,
    "folder": "055-take-a-plane",
    "category": 8
  }
]